export default "__VITE_ASSET__CBc3IMue__"